import { createStore } from 'vuex'
import { auth } from './auth.module'
import { account } from './account.module'
import { filters } from './filters.module'
import getUserLocale from 'get-user-locale'
import moment from 'moment'

const store = createStore({
  state: {
    profileRefresh: false,
  },
  actions: {
    updateProfileRefresh({ commit }, value) {
      commit('SET_PROFILE_REFRESH', value)
    },
  },
  mutations: {
    SET_PROFILE_REFRESH(state, value) {
      state.profileRefresh = value
    },
  },

  getters: {
    profileRefresh: (state) => state.profileRefresh,
    formattedAmount: (state) => (data) => {
      const currencyType = data.commission_currency_type || {}
      let currencyCode = currencyType.code || data.commission_currency_type_name
      let amount = data.commission_fee || data.reward || 0 // Default value if undefined
      const userLocal = getUserLocale() // Get user locale

      const noReward = String(amount).match(/\d+/g)

      if (noReward === null) {
        return amount
      }

      // Para birimi kodu kontrolü
      if (!currencyCode || currencyCode === '') {
        currencyCode = 'USD' // Varsayılan para birimi
      }

      if (currencyCode === 'TL') {
        currencyCode = 'TRY'
      }

      try {
        return new Intl.NumberFormat(userLocal, {
          style: 'currency',
          currency: currencyCode.trim().toUpperCase(),
          minimumFractionDigits: 0,
        }).format(Number(amount))
      } catch (error) {
        console.warn('Invalid currency code:', currencyCode)
        return `${Number(amount).toLocaleString()} ${currencyCode}`
      }
    },

    formatDateToCustomString: (state) => (data) => {
      return moment(moment.parseZone(data)).format('MMM DD, YYYY')
    },

    sanitizeInput: () => (input) => {
      if (!input || typeof input !== 'string') return input

      return (
        input
          .replace(/["]/g, '&quot;')
          .replace(/[']/g, '&#39;')
          .replace(/[`]/g, '&#96;')
          .replace(/[\^]/g, '&#94;')
          .replace(/[!]/g, '&#33;')
          // Aşağıdaki karakterler veritabanı sorgularında sorun çıkarabilir
          .replace(/[\\]/g, '&#92;')
          .replace(/[%]/g, '&#37;')
          .replace(/[_]/g, '&#95;')
      )
    },

    deserializeInput: () => (input) => {
      if (!input || typeof input !== 'string') return input

      return input
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&#96;/g, '`')
        .replace(/&#94;/g, '^')
        .replace(/&#33;/g, '!')
        .replace(/&#92;/g, '\\')
        .replace(/&#37;/g, '%')
        .replace(/&#95;/g, '_')
    },
  },

  modules: {
    auth: auth,
    account: account,
    filters: filters,
  },
})

export default store
